import { styled } from "@acko-tech/building-blocks.ui.common";

export const Container = styled.div`
  padding: 12px;
  margin: 20px 0 32px 0;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  border-radius: 12px;
  color: #36354c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  width: 100%;
  border: 1px solid #efe9fb;
  align-items: center;
  background: #f9f6ff;
  gap: 12px;
  span {
    font-weight: 600;
    color: #7c47e1;
  }
`;
